import { createFileRoute, redirect } from '@tanstack/react-router';
import { HomePage } from '@/features/home/pages/home-page';
import { dashboardLanding } from '@/lib/home';
import { meQueryOptions } from '@/lib/me';
import { pickActiveMembership } from '@/lib/membership';
import { useSession } from '@/stores/session';

export const Route = createFileRoute('/_app/')({
  // `?classic=1` keeps the role home reachable ("หน้าแรกเดิม" link on the dashboard).
  validateSearch: (s: Record<string, unknown>): { classic?: true } => (s.classic ? { classic: true } : {}),
  // Clinic owners / managers land on the dashboard; the parent `_app` guard has already loaded /v1/me.
  beforeLoad: async ({ context, search }) => {
    if (search.classic) return;
    const me = await context.queryClient.ensureQueryData(meQueryOptions);
    const m = pickActiveMembership(me.memberships, useSession.getState().tenantId);
    const target = m ? dashboardLanding(m) : undefined;
    if (target) throw redirect({ to: target });
  },
  component: HomePage,
});
